import { Languages } from '@landr/core.models';

const getEnvSuffix = (environment) => {
    switch (environment) {
        case 'development':
            return '-dev';
        case 'demo':
            return '-demo';
        case 'partner':
            return '-partner';
        case 'production':
        default:
            return '';
    }
};
const getEnvDomain = (environment) => `${getEnvSuffix(environment)}.landr.com`;
const getDevOrProdEnvSuffix = (environment) => {
    switch (environment) {
        case 'development':
        case 'demo':
        case 'partner':
            return '-dev';
        case 'production':
        default:
            return '';
    }
};
const getWebAppLink = (env, pathname = '/') => {
    const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
    if (currentHostname && currentHostname.match(/^local.landr.com$/)) {
        return `https://local.landr.com:9102${pathname}`;
    }
    else {
        return `https://app${getEnvSuffix(env)}.landr.com${pathname}`;
    }
};
const getSameOriginLink = (pathname) => {
    return `${window.location.origin}${pathname}`;
};
const getSupportLink = (language, pathname = '/') => {
    return `https://support.landr.com/hc/${language === Languages.English ? 'en-us' : language}${pathname}`;
};
const getGuestSiteLink = (env, pathname = '/') => {
    let domain;
    switch (env) {
        case 'development':
            domain = 'dev.landr.com';
            break;
        case 'demo':
            domain = 'demo.landr.com';
            break;
        case 'partner':
            domain = 'partner.landr.com';
            break;
        case 'production':
        default:
            domain = 'www.landr.com';
            break;
    }
    return `https://${domain}${pathname}`;
};
const getPluginsLink = (env, pathname = '/') => {
    return `https://plugins${getEnvDomain(env)}${pathname}`;
};
const getSamplesLink = (env, pathname = '/') => `https://samples${getEnvDomain(env)}${pathname}`;
const getChromaticLink = (env, pathname = '/') => `https://chromatic${getEnvDomain(env)}${pathname}`;
const getSessionsLink = (env) => {
    return `${getWebAppLink(env)}sessions`;
};
const getSessionsFreeRoomLink = (env, pathname = '/') => `https://sessions-free${getEnvDomain(env)}${pathname}`;
const getSessionsPremiumRoomLink = (env, pathname = '/') => `https://sessions-premium${getEnvDomain(env)}${pathname}`;
const getNetworkLink = (env, pathname = '') => `https://network${getEnvDomain(env)}${pathname}`;
const getEducationLink = (env, pathname = '/') => `https://learn${getDevOrProdEnvSuffix(env)}.landr.com${pathname}`;
const getRootApiUri = (env, pathname) => {
    return `https://api3${getEnvSuffix(env)}.landr.com${pathname !== null && pathname !== void 0 ? pathname : ''}`;
};
const getMsApiUri = (env, msName) => {
    return getRootApiUri(env, `/${msName}/api`);
};
const LOCAL_GRAPHQL_HTTP_URI = 'http://localhost:4002';
const LOCAL_GRAPHQL_WS_URI = 'ws://localhost:4002';
const getGraphqlHttpUri = (env, params) => {
    var _a;
    // Core-BFF must have `/` at the end to be reachable
    return (params === null || params === void 0 ? void 0 : params.isLocal) ? LOCAL_GRAPHQL_HTTP_URI : getRootApiUri(env, `/core-bff-v2${(_a = params === null || params === void 0 ? void 0 : params.pathname) !== null && _a !== void 0 ? _a : '/'}`);
};
const getGraphqlWsUri = (env, isLocal) => {
    if (isLocal) {
        return LOCAL_GRAPHQL_WS_URI;
    }
    if (env === 'production') {
        return `wss://ws.landr.com/core-bff-v2/`;
    }
    return `wss://api3${getEnvSuffix(env)}-ws.landr.com/core-bff-v2/`;
};
const getAssetsUri = (env, pathname) => {
    return `https://assets${getEnvSuffix(env)}.landr.com${pathname !== null && pathname !== void 0 ? pathname : ''}`;
};

export { getAssetsUri, getChromaticLink, getEducationLink, getEnvDomain, getEnvSuffix, getGraphqlHttpUri, getGraphqlWsUri, getGuestSiteLink, getMsApiUri, getNetworkLink, getPluginsLink, getRootApiUri, getSameOriginLink, getSamplesLink, getSessionsFreeRoomLink, getSessionsLink, getSessionsPremiumRoomLink, getSupportLink, getWebAppLink };
